import {
  Header,
  HeaderFilterContainer,
  SearchFilterWrapper,
  SearchSelectResponsive,
  setDateFromStorage,
  TypeSelectorAndSearch,
  useTranslation
} from '@fareye/common'
import SummaryFilter from '../components/Summary'
import { IDateRange } from '@fareye/types'
import { Link } from 'react-router-dom'
import { DatePicker, Flex, Grid, SearchSelect } from '@fareye/ui'
import {
  currenthhmmA,
  dMmm,
  getQueryParams,
  getSearchFilterFromSession,
  groupBy,
  isEmpty,
  yyyyMmDd
} from '@fareye/utils'
import { labelColor } from '../config/colors'
import queryString, { ParsedQuery } from 'query-string'
import React from 'react'
import { SHIPMENT_TYPES } from '../config/constants'
import { mapping } from '../config/mapComponents'

import { IInTransitPerformance } from '../utility/types'
import { TransportModeFilter } from '../components/TransportModeFilter'
import {
  MultiModalHeaderContainer,
  SummarFilterWrapper,
  SummaryWithModesSelector
} from '../style/styled'

export function MultiModalLayout({
  match,
  config,
  history,
  location,
  routesConfig
}: IInTransitPerformance) {
  const [isFirst, setIsFirst] = React.useState(false)
  const searchParams: ParsedQuery<string | Date> = queryString.parse(
    location.search
  )
  const {
    links,
    carryDate,
    showDatePicker,
    showSummary,
    showTimezone,
    toggleContent,
    pageType
  } = config.config
  const { t } = useTranslation()

  let pageHeaderType: any = pageType ? pageType : SHIPMENT_TYPES
  const { children, styling, globalSearchPageId } = config
  const { style, className, bodyBgColor, variant, layoutStyle } = styling
  const [globalSearch, setGlobalSearch] = React.useState(
    getSearchFilterFromSession(globalSearchPageId)
  )
  const [summaryFilter, setSummaryFilter] = React.useState<any>({})
  const [summaryData, setSummaryData] = React.useState([])
  const [transportModeFilter, setTransportModeFilter] = React.useState<any>([])
  const [selectedMode, setSelectedMode] = React.useState('All')

  React.useEffect(() => {
    if (isEmpty(summaryFilter) && !isEmpty(summaryData)) {
      setSummaryFilter(summaryData[0])
    }
  }, [summaryData])

  const filterSelectedKey = toggleContent
    ? toggleContent.filter((item: any) =>
        item.link ? item.link === match.path : true
      )
    : []
  const [selectedKey, setSelectedKey] = React.useState(
    filterSelectedKey.length ? filterSelectedKey[0].selectedKey : ''
  )
  const [selectedShipmentType, setSelectedShipmentType] = React.useState(
    pageHeaderType[0]
  )
  const [lastUpdate, setLastUpdate] = React.useState<string>('')
  const [dateRange, setDateRange] = React.useState(() => {
    return setDateFromStorage({
      showDatePicker: !!showDatePicker,
      carryDate,
      searchParams
    })
  })

  const { startDate, endDate } = dateRange as IDateRange<Date>

  const query = {
    ...searchParams,
    startDate,
    endDate
  }

  const queryParams = getQueryParams(query)
  React.useEffect(() => {
    if (isFirst) {
      setIsFirst(true)
      history.push({
        pathname: match.url,
        search: queryParams
      })
    }
    setLastUpdate(currenthhmmA())
  }, [queryParams])

  //   React.useEffect(() => {
  //     setSummaryFilter([])
  //   }, [selectedShipmentType])

  React.useEffect(() => {
    if (showDatePicker) {
      let prevStartDate = searchParams.startDate
      let prevEndDate = searchParams.endDate
      if (prevStartDate !== startDate || prevEndDate !== endDate) {
        const queryParams = getQueryParams({
          ...queryString.parse(location.search),
          startDate,
          endDate
        })
        history.replace({
          pathname: match.url,
          search: queryParams
        })
      }
    }
  }, [dateRange])

  function populateSearchQuery() {
    let searchObj: any = {}
    if (!isEmpty(globalSearch)) {
      const filters = groupBy(globalSearch, 'key')
      Object.keys(filters).forEach((ele: any) => {
        searchObj[ele] = filters[ele].map((item: any) => item.value)
      })
    }
    return searchObj
  }

  function setDateRangeAndStorage(dates: IDateRange<string | Date>) {
    localStorage.setItem('date', JSON.stringify(dates))
    setDateRange(dates as IDateRange<Date>)
  }
  const fileName = (match.params && (match.params as any).id) || 'InTransit'

  const { component } = (config as any).children[selectedShipmentType.value]
  const ComponentRender = (mapping as any)[component]
  //   const apiFilter = React.useMemo(() => {
  //     let filterConfig = config?.filters?.apiFilter
  //     filterConfig.queryParams.data_source = selectedShipmentType.dataSource
  //     return filterConfig
  //   }, [selectedShipmentType])

  return (
    <Flex column width={1} style={{ ...layoutStyle, height: '100%' }}>
      <Header
        match={match}
        toggle={toggleContent}
        lastUpdate={lastUpdate}
        selectedKey={selectedKey}
        setSelectedKey={setSelectedKey}
        startDate={startDate}
        endDate={endDate}
        location={location}
        history={history}
        routesConfig={routesConfig}
        rightTopCorner={
          <Flex>
            {showDatePicker && (
              <DatePicker
                variant="fareyeV2"
                formatter={yyyyMmDd}
                onDateRangeSelected={setDateRangeAndStorage}
                value={dateRange}
              />
            )}
          </Flex>
        }
        showTimezone={showTimezone}
      >
        <HeaderFilterContainer>
          <MultiModalHeaderContainer>
            <TypeSelectorAndSearch>
              <SearchSelectResponsive>
                <SearchSelect
                  options={pageHeaderType || []}
                  value={selectedShipmentType}
                  placeholder={t('Select Shipment Type')}
                  onChange={(item: any) => {
                    setSelectedShipmentType(item)
                  }}
                  t={t}
                  style={{
                    container: {
                      width: '100%',
                      borderRadius: '0px'
                    },
                    wrapper: {
                      width: '100%',
                      alignItems: 'flex-start'
                    },
                    control: {
                      height: '46px'
                    },
                    dropdownIndicator: {
                      display: 'block',
                      transform: 'rotate(0deg) !important'
                    }
                  }}
                />
              </SearchSelectResponsive>
              <SearchFilterWrapper
                apiFilter={config.filters && (config.filters as any).apiFilter}
                customKeyMapping={(config.filters as any)?.customKeyMapping}
                apiFav={config.filters && (config.filters as any).apiFav}
                pageId="intransit"
                search={globalSearch}
                // summaryKeys={Object.keys(summaryData).map((key: any) => snakeCase(key))}
                summaryKeys={['status', 'transport_mode']}
                setSearch={setGlobalSearch}
                startDate={startDate}
                endDate={endDate}
                showTimezone={showTimezone}
              />
            </TypeSelectorAndSearch>
            {links?.allTrips ? (
              <Flex style={{ flex: 1, justifyContent: 'flex-end' }}>
                <Link
                  to={`${links.allTrips}?${queryParams}`}
                  style={{
                    fontSize: '14px',
                    marginTop: '15px',
                    color: labelColor.linkText
                  }}
                >
                  {t('View All Trips')}
                </Link>
              </Flex>
            ) : null}
          </MultiModalHeaderContainer>
          {showSummary || !isEmpty(transportModeFilter) ? (
            <SummaryWithModesSelector>
              {showSummary ? (
                <SummarFilterWrapper>
                  <SummaryFilter
                    summaryData={summaryData}
                    summaryFilter={summaryFilter}
                    setSummaryFilter={setSummaryFilter}
                  />
                </SummarFilterWrapper>
              ) : null}

              {!isEmpty(transportModeFilter) ? (
                <TransportModeFilter
                  summaryList={transportModeFilter}
                  selectedMode={selectedMode}
                  setSelectedMode={setSelectedMode}
                />
              ) : null}
            </SummaryWithModesSelector>
          ) : null}
        </HeaderFilterContainer>
      </Header>
      <div style={{ flexGrow: 1, background: bodyBgColor }}>
        <Grid
          gridGap={variant.gridGap}
          gridTemplateColumns={variant.gridTemplateColumns}
          style={{ ...style }}
          className={className}
        >
          <ComponentRender
            key={selectedShipmentType.value}
            match={match}
            fileName={`${fileName}_${dMmm()}`}
            history={history}
            mapping={mapping}
            location={location}
            setSummaryFilter={setSummaryFilter}
            endDate={showDatePicker ? endDate : null}
            startDate={showDatePicker ? startDate : null}
            config={(config as any).children[selectedShipmentType.value]}
            type={selectedShipmentType.value}
            setTransportModeFilter={setTransportModeFilter}
            transportModeFilter={transportModeFilter}
            selectedMode={selectedMode}
            setSummaryData={setSummaryData}
            summaryFilter={summaryFilter}
            globalSearch={globalSearch}
          />
        </Grid>
      </div>
    </Flex>
  )
}
